import type { MainMenuItem, SubMenuItem } from '../side-menu-interfaces';

type ContextConfig = {
  isDriver: boolean;
  isSiteAvailable: boolean;
  mainRoleId: string;
};

export function isMenuItemVisible(menuItem: MainMenuItem, config: ContextConfig) {
  const { subMenuItems, roles } = menuItem;
  const { isDriver, isSiteAvailable, mainRoleId } = config;

  if (!subMenuItems.length && roles && isSiteAvailable) {
    return roles.some(role => role.id === mainRoleId);
  }

  if (!isSiteAvailable) {
    return isDriver ? false : subMenuItems.some(menuItem => menuItem.showWhenSiteUnavailable);
  }

  return subMenuItems.some(menuItem => {
    if (menuItem.availableForRoles) {
      return menuItem.availableForRoles.includes(mainRoleId);
    }
    return menuItem.roles.some(role => role.id === mainRoleId);
  });
}

export function isSubMenuItemVisible(subMenuItem: SubMenuItem, config: ContextConfig) {
  const { availableForRoles, roles, showWhenSiteUnavailable } = subMenuItem;
  const { isDriver, isSiteAvailable, mainRoleId } = config;

  if (availableForRoles) {
    return availableForRoles.includes(mainRoleId);
  }

  if (!isSiteAvailable) {
    return !isDriver && showWhenSiteUnavailable;
  }

  return roles.some(role => role.id === mainRoleId);
}
